import InfoRounded from '@mui/icons-material/InfoRounded';
import IconButton from '@mui/material/IconButton';
import type { SxProps } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { Box } from '@mui/system';
import { RHFCheckboxField } from '@openx/components-core/lib/CheckboxField/RHFCheckboxField';

type CheckBoxWithTooltipProps = {
  name: string;
  label: string;
  tooltipText: string;
  valueOfChecked: string;
  disabled?: boolean;
  onChange?: (name: string, value: boolean) => void;
};

const boxStyles: SxProps = {
  display: 'flex',
  gap: 1,
  mt: 1,
};

export const CheckBoxWithTooltip = ({
  name,
  label,
  tooltipText,
  disabled,
  valueOfChecked,
  onChange,
}: CheckBoxWithTooltipProps) => {
  return (
    <Box sx={boxStyles}>
      <RHFCheckboxField
        name={name}
        valueOfChecked={valueOfChecked}
        disabled={disabled}
        valueOfUnchecked={null}
        formControlLabelSx={{ m: 0 }}
        label={label}
        onChange={event => {
          // Prevent the checkbox from being unchecked when it is disabled
          if (disabled && !event.target.checked) {
            event.preventDefault();
          }

          if (onChange) {
            onChange(name, event.target.checked);
          }
        }}
      />
      <Tooltip title={tooltipText} placement="right">
        <IconButton size="small" aria-label={`${label} info`}>
          <InfoRounded />
        </IconButton>
      </Tooltip>
    </Box>
  );
};
